/**
 * @generated SignedSource<<ed26a70e3f3c50a70071869b1a6273a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingDurationCourtInnerFragment$data = {
  readonly agenda: {
    readonly facility: {
      readonly publicBookingPermissionSet: {
        readonly customerCanSelectCourt: boolean | null | undefined;
      } | null | undefined;
    };
    readonly id: string;
  };
  readonly course?: {
    readonly courseBucket: {
      readonly id: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
  };
  readonly id: string;
  readonly time?: string;
  readonly " $fragmentType": "BookingDurationCourtInnerFragment";
};
export type BookingDurationCourtInnerFragment$key = {
  readonly " $data"?: BookingDurationCourtInnerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingDurationCourtInnerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingDurationCourtInnerFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customerCanSelectCourt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "time",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseBucket",
              "kind": "LinkedField",
              "name": "courseBucket",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "8de771aa77a36025018ee7edbb46a041";

export default node;
